<template>
  <div>
    <div v-if="isLoading" class="loader"></div>
    <div
      v-if="!isLoading"
      style="box-shadow: 0 0 1px 1px rgba(222, 226, 222, 0.8)"
    >
      <div class="header-group">
        <div
          v-if="title.length > 0"
          style="font-size: 1.3em; text-transform: uppercase"
        >
          {{ title }}
        </div>
        <div class="control-group">
          <div class="control-title">SEARCH</div>
          <input
            class="control"
            placeholder="Type something..."
            @input="searchValue = $event.target.value.toLowerCase()"
          />
        </div>
        <div v-if="filterIndex >= 0" class="control-group">
          <div class="control-title">SHOWING</div>
          <select class="control" v-model="filterValue">
            <option selected="true">All</option>
            <option
              v-for="(option, optionIdx) in filterOptions"
              :key="optionIdx"
            >
              {{ option }}
            </option>
          </select>
        </div>
        <slot></slot>
      </div>
      <div class="table-group">
        <div v-if="model.data && model.data.length === 0">No Results Found</div>
        <table v-else>
          <thead>
            <tr>
              <th
                scope="col"
                v-for="(title, titleIdx) in model.title"
                :key="titleIdx"
              >
                {{ title }}
              </th>
              <th scope="col" v-if="actions">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(item, itemIdx) in tableItems"
              :key="itemIdx"
              @click="$emit('update:selectedId', item.id)"
            >
              <td
                :data-label="model.title[idx]"
                v-for="(it, idx) in item.data"
                :key="idx"
              >
                {{ it.value }}
              </td>
              <td v-if="actions">
                <div class="action-group">
                  <div
                    @click="$emit('onAction', action, item.id)"
                    class="action underline-on-hover"
                    v-for="(action, actionIdx) in actions"
                    :key="actionIdx"
                  >
                    {{ action }}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isLoading: Boolean,
    selectedId: Number,
    filterIndex: {
      default: -1,
      type: Number
    },
    title: {
      default: '',
      type: String
    },
    model: Object,
    actions: Array
  },
  data() {
    return {
      searchValue: '',
      filterValue: 'All'
    };
  },
  computed: {
    tableItems() {
      let tableData = this.model.data;
      // make sure the data exists, return empty array if null
      if (tableData) {
        let items = [];
        // right now search the first index
        for (let i = 0; i < tableData.length; ++i) {
          // dont include if filter exists and the item not eq the filter value
          if (
            this.filterValue !== 'All' &&
            tableData[i].data[this.filterIndex].value !== this.filterValue
          ) {
            continue;
          }
          // filter the string that contains the search value
          if (
            tableData[i].data[0].value.toLowerCase().includes(this.searchValue)
          ) {
            items.push(tableData[i]);
          }
        }
        return items;
      }
      return [];
    },
    filterOptions() {
      let tableData = this.model.data;
      if (tableData && this.filterIndex >= 0) {
        let options = [];
        for (let i = 0; i < tableData.length; ++i) {
          let filterItem = tableData[i].data[this.filterIndex].value;
          if (filterItem && !options.includes(filterItem)) {
            options.push(filterItem);
          }
        }
        return options;
      }
      return null;
    }
  }
};
</script>

<style scoped>
table {
  box-shadow: 0 0 1px 1px rgba(222, 226, 222, 0.5);
  border-collapse: collapse;
  margin: 0;
  padding: 0;
  width: 100%;
  table-layout: fixed;
}
table tr {
  background-color: #f8f8f8;
  border: 1px solid #ddd;
  padding: 0.35em;
}
tbody tr:hover {
  cursor: pointer;
  background-color: #ecf0f1 !important;
}
tbody tr:nth-child(odd) {
  background-color: white;
}
table td {
  border: 1px solid #dddddd;
}
table th,
table td {
  padding: 0.625em;
  text-align: center;
}
table th {
  font-size: 0.85em;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}
.table-group {
  padding: 15px;
}
.header-group {
  display: flex;
  justify-content: space-between;
  background-color: #ecf0f1;
  padding: 10px;
}
.control-group {
  display: flex;
  align-items: center;
}
.control {
  border: 1px solid #cecece;
  padding: 0.6em 1.4em 0.5em 0.8em;
  font-size: 0.8rem;
  height: 35px;
  color: #464a4c;
  border-radius: 0.25rem;
}
.control-title {
  margin-right: 10px;
  font-size: 0.8em;
}
.action-group {
  display: flex;
  justify-content: space-around;
}
.action {
  cursor: pointer;
  color: rgb(34, 52, 107);
  padding-left: 2px;
  padding-right: 2px;
}

@media screen and (max-width: 768px) {
  table {
    border: 0;
  }
  table thead {
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
  }
  table tr {
    border-bottom: 3px solid #ddd;
  }
  table td {
    border: none;
    display: block;
    font-size: 0.8em;
    text-align: right;
  }
  table td::before {
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
  }
  .table-group {
    padding: 0px;
  }
  .header-group {
    flex-flow: column;
  }
  .control-group {
    padding: 5px;
    justify-content: space-between;
  }
  .control {
    width: 180px;
    height: 32px;
  }
  .action {
    font-weight: bold;
    /* text-transform: uppercase; */
  }
}
</style>
